import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-becf84ae"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["onClick"];
const _hoisted_2 = {
  key: 1,
  class: "card-item-text"
};
const _hoisted_3 = {
  key: 2,
  class: "priview-btn"
};
import { CircleCloseFilled, Document } from '@element-plus/icons-vue';
import { useDownload } from '@/common/hooks/useDownload';
import { EnumFileType } from '@/common/staticDict/index';
import { getFileType } from '@/common/utils';
import PreviewDialog from '@/components/Preview/Dialog';

import { computed, ref, nextTick } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    fileList: {
      default: () => []
    },
    type: {
      default: 'text'
    },
    direction: {
      default: 'vertical'
    },
    supportPreview: {
      type: Boolean,
      default: true
    },
    supportDownload: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    supportAdd: {
      type: Boolean,
      default: true
    }
  },
  emits: ['remove', 'add', 'preview'],
  setup(__props, {
    emit: __emit
  }) {
    const {
      downloadFile
    } = useDownload();
    const props = __props;
    const emit = __emit;
    const getFileList = computed(() => {
      return props.fileList.map(file => {
        return {
          ...file,
          type: getFileTypeByName(file),
          error: false
        };
      });
    });
    const getFlexDirection = computed(() => {
      return {
        'flex-direction': props.direction === 'vertical' && props.type !== 'card' ? 'column' : 'row'
      };
    });
    const showPreview = ref(false);
    const fileIndex = ref(0);
    const getFileTypeByName = file => {
      if (file && file.type) {
        return file.type;
      } else {
        return getFileType(file.name);
      }
    };
    const onRemoveFile = (file, fileList) => {
      const index = fileList.findIndex(item => item.url === file.url);
      fileList.splice(index, 1);
      emit('remove', file, fileList);
    };
    const onPreviewFile = (file, fileList) => {
      if (!props.supportPreview) return;
      if (props.supportPreview) {
        fileIndex.value = fileList.findIndex(item => item.url === file.url);
        nextTick(() => {
          showPreview.value = true;
          emit('preview', file, fileList);
        });
      } else if (props.supportDownload) {
        downloadFile(file.url, file.name);
      }
    };
    const onAddFile = () => {
      emit('add');
    };
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      return _openBlock(), _createElementBlock("div", {
        class: "file-list",
        style: _normalizeStyle(_unref(getFlexDirection))
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getFileList), file => {
        return _openBlock(), _createBlock(_component_el_tooltip, {
          effect: "dark",
          content: file.name,
          placement: "top",
          disabled: _ctx.type === 'text',
          key: file.url
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: _normalizeClass(["file-item", _ctx.type]),
            style: _normalizeStyle({
              width: _ctx.type === 'text' && _ctx.direction === 'vertical' ? '100%' : undefined,
              border: _ctx.type === 'card' && !_ctx.readonly ? '1px dashed #999999' : 'none'
            }),
            onClick: _withModifiers($event => onPreviewFile(file, _ctx.fileList), ["stop"])
          }, [_ctx.type === 'card' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [file.type === _unref(EnumFileType).IMAGE ? (_openBlock(), _createBlock(_component_el_image, {
            key: 0,
            src: file.url,
            fit: "cover",
            style: {
              "width": "100%",
              "height": "100%"
            }
          }, null, 8, ["src"])) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_icon, {
            style: {
              "font-size": "24px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_unref(Document))]),
            _: 1
          })])), _ctx.supportPreview ? (_openBlock(), _createElementBlock("div", _hoisted_3, "预览")) : _createCommentVNode("", true), !_ctx.readonly ? (_openBlock(), _createBlock(_component_el_icon, {
            key: 3,
            class: "close-btn",
            onClick: _withModifiers($event => onRemoveFile(file, _ctx.fileList), ["stop"])
          }, {
            default: _withCtx(() => [_createVNode(_unref(CircleCloseFilled))]),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createElementVNode("span", {
            style: _normalizeStyle({
              'flex-grow': _ctx.direction === 'vertical' ? 1 : 0,
              width: _ctx.direction === 'vertical' ? '100px' : undefined,
              'margin-right': _ctx.direction === 'vertical' ? undefined : '8px'
            })
          }, _toDisplayString(file.name), 5), !_ctx.readonly ? (_openBlock(), _createBlock(_component_el_icon, {
            key: 0,
            class: "close-btn",
            style: {
              "margin-left": "6px"
            },
            onClick: _withModifiers($event => onRemoveFile(file, _ctx.fileList), ["stop"])
          }, {
            default: _withCtx(() => [_createVNode(_unref(CircleCloseFilled))]),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true)], 64))], 14, _hoisted_1)]),
          _: 2
        }, 1032, ["content", "disabled"]);
      }), 128)), _ctx.supportAdd && _ctx.$slots.default ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["file-item", _ctx.type]),
        onClick: onAddFile
      }, [_renderSlot(_ctx.$slots, "default")], 2)) : _createCommentVNode("", true), _unref(showPreview) ? (_openBlock(), _createBlock(_unref(PreviewDialog), {
        key: 1,
        visible: _unref(showPreview),
        "file-list": _ctx.fileList,
        defaultIndex: _unref(fileIndex),
        readonly: !_ctx.supportDownload,
        onClose: _cache[0] || (_cache[0] = $event => showPreview.value = false)
      }, null, 8, ["visible", "file-list", "defaultIndex", "readonly"])) : _createCommentVNode("", true)], 4);
    };
  }
});